import React from 'react';
import Avatar from '@material-ui/core/Avatar';

export default function FallbackAvatars({ imageUrl, alt, className }) {

    return (
        <Avatar alt={alt} src={imageUrl || '/broken-image.jpg'} className={`profile-image m-1 ${className}`} />
    );
}